<div [ngClass]="vertical ? 'tabs-container-vertical' : 'tabs-container-horizontal'">
    <div
        *ngFor="let tab of tabs; index as i"
        class="tab"
        [ngClass]="{ 'tab-selected': i === currentTabIndex }"
        role="tab"
        tabindex="0"
        (click)="onSelect(i); $event.stopPropagation()">
        {{ tab.labelPath | labelsProvider }}
        <span *ngIf="tab.isBeta" class="beta-badge">Beta</span>
        <img
            class="icon-field"
            *ngIf="tab.tooltipLabelPath"
            src="assets/images/common/info.svg"
            height="16px"
            title="{{ tab.tooltipLabelPath | labelsProvider }}" />
        <div class="border" *ngIf="i === currentTabIndex && !vertical"></div>
    </div>
</div>
